export default {
  gameSummary: {
    sections: {
      matchupInformation: "Matchup information",
      rankings: "Rankings",
    },
    labels: {
      record: "Record",
      rank: "Rank",
      type: "Type",
      stat: "Stat",
      filterByGame: "Filter by game",
      position: "Position",
      injury: "Injury",
      status: "Status",
      trend: "Trend",
    },
    standingTypes: {
      division: "Division",
      conference: "Conference",
      league: "League",
      overall: "Overall",
    },
    rankingSides: {
      FOR: "FOR",
      AGAINST: "AGAINST",
    },
    statAbbreviations: {
      PTS: "PTS",
      "SCORE %": "SCORE %",
      "SCORE%": "SCORE%",
      PLAYS: "PLAYS",
      "NET YDS": "NET YDS",
      "PASS YDS": "PASS YDS",
      "PASS ATT": "PASS ATT",
      "PASS COMPL": "PASS COMPL",
      "PASS TD": "PASS TD",
      "RUSH YDS": "RUSH YDS",
      "RUSH ATT": "RUSH ATT",
      "RUSH TD": "RUSH TD",
      "TOTAL TDS": "TOTAL TDS",
      "RZ%": "RZ%",
      "1D": "1D",
      "3D%": "3D%",
      "4D%": "4D%",
      INT: "INT",
      TO: "TO",
      SACKS: "SACKS",
      FUML: "FUML",
      G: "G",
      SOG: "SOG",
      SAT: "SAT",
      "CF%": "CF%",
      "PP%": "PP%",
      PIM: "PIM",
      PPG: "PPG",
      SHG: "SHG",
      "SH%": "SH%",
      BLK: "BLK",
      FTM: "FTM",
      FTA: "FTA",
      "FT%": "FT%",
      FGM: "FGM",
      FGA: "FGA",
      "FG%": "FG%",
      "3PTM": "3PTM",
      "3PTA": "3PTA",
      "3PT%": "3PT%",
      "TS%": "TS%",
      "eFG%": "eFG%",
      TRB: "TRB",
      AST: "AST",
      STL: "STL",
      R: "R",
      H: "H",
      "1B": "1B",
      "2B": "2B",
      "3B": "3B",
      TB: "TB",
      ER: "ER",
      HR: "HR",
      RBI: "RBI",
      BB: "BB",
      SO: "SO",
      E: "E",
      AVG: "AVG",
      OBP: "OBP",
      SLG: "SLG",
      OPS: "OPS",
      POS: "POS",
      SHO: "SHO",
      SOT: "SOT",
      COR: "COR",
      OFF: "OFF",
      FLS: "FLS",
      "2YELRED": "2YELRED",
      YEL: "YEL",
      RED: "RED",
      T: "T",
      "CR%": "CR%",
      RM: "RM",
      LB: "LB",
      K: "K",
      KM: "KM",
    },
    quickPicks: {
      moneyline: "Moneyline",
      spread: "Spread",
      total: "Total",
    },
  },
};